<template>
  <div>
    <terminal-table
      class="col-12"
      :currentPage="data.current_page"
      :perPage="data.per_page"
      v-if="isMobile"
      :getData="fetchData"
      :pageCount="data.last_page"
      :options="tableProps"
      :datas="data"
      :headers="columns"
    >
      <template #filters>
        <slot name="filters"></slot>
      </template>
    </terminal-table>

    <data-table
      v-if="!isMobile"
      :data="data"
      @row-clicked="rowClicked"
      :columns="columns"
      :debounce-delay="3000"
      :translate="translate"
      :pagination="paginate"
      :per-page="[10, 25, 50, 100,200, 500,1000]"
      @on-table-props-changed="onTablePropsChanged"
      class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
    >
      <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="scope">
        <slot :name="slotName" v-bind="scope"></slot>
      </template>
      <template #filters="scope">
        <slot name="filters" v-bind="scope"></slot>
      </template>
      <template #top="scope">
        <slot name="top" v-bind="scope"></slot>
      </template>
    </data-table>
  </div>
</template>

<script>
import { dataTableProps } from "@/main";

export default {
  name: "MixedTable",
  props: {
    // ۱. 👈 این قسمت اضافه شد: دریافت فیلترها از کامپوننت پدر
    tbProps: {
      type: Object,
      default: () => ({})
    },
    fetchData: {
      type: Function,
      default: () => {},
      require: true,
    },
    reloadTable: {
      type: Function,
      default: () => {},
      require: true,
    },
    columns: {
      type: Array,
      require: true,
    },
    data: {
      type: Object,
      require: true,
    },
    rowClicked: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      translate: { ...dataTableProps.translate },
      paginate: { ...dataTableProps.pagination },
      tableProps: JSON.parse(JSON.stringify(dataTableProps.tableProps)),
    }
  },
  methods: {
    onTablePropsChanged(props) {
      if (this.tbProps && this.tbProps.length) {
        props.length = this.tbProps.length;
      }

      this.tableProps = props;
      this.reloadTable(props);
    }
  },
  mounted() {
    this.reloadTable(this.tableProps); 
  },
  watch: {
    isMobile(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchData();
      }
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return true;
        case "md":
        case "lg":
        case "xl":
          return false;
      } 
    },
  }
};
</script>

<style scoped></style>
